// extracted by mini-css-extract-plugin
export default {"Container":"BranchActionMenu-module__Container--YVES2","ActionButtonGroup":"BranchActionMenu-module__ActionButtonGroup--cJwmc"};